import { IApplicationState } from '../../types/redux';
import { EDealType } from '../../types/dealType';
import { WJ } from '../../constants/symbols';
import { getPrettyPrice } from '@cian/valuation-utils-component';
import { selectEstimationByDealType } from './selectEstimationByDealType';
import { selectDealType } from '../page';

export interface IFormatEstimationPricesParams {
  price: number;
  priceFrom: number;
  priceTo: number;
  dealType: EDealType;
}

export const formatEstimationPrices = (params: IFormatEstimationPricesParams) => {
  const unit = params.dealType === EDealType.Sale ? '₽' : `₽${WJ}/${WJ}мес`;
  const price = getPrettyPrice(params.price, { unit });
  const priceFrom = getPrettyPrice(params.priceFrom, { showUnit: false, showPostfix: false });
  const priceTo = getPrettyPrice(params.priceTo, { unit });

  return { price, priceFrom, priceTo };
};

export const selectEstimationPrettyPrices = (state: IApplicationState) => {
  const dealType = selectDealType(state);
  const estimation = selectEstimationByDealType(dealType)(state);

  if (!estimation || !estimation.data) {
    return null;
  }

  return formatEstimationPrices({ ...estimation.data, dealType });
};
